import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { selectedHotelSelector } from '../../property/propertySlice';
import ModuleListUpdate from './moduleListUpdate/ModuleListUpdate';
import ModuleSelect from './moduleSelect/ModuleSelect';
import ModuleSummary from './moduleSummary/ModuleSummary';
import { Button } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { getHotelSystemsModuleSummaryData } from '../../../utils/IntegrationsAPIUtils';
import LinearProgressBar from '../../../shared/progress-bar/Progress';
import { GUEST_ROOM_EXP, HOTEL_SERVICES } from '../../../constants/ConfigurationsConst';
import GuestRoomExperience from './moduleSummary/guest-room-experience/Guest-Room-Experience';
import HotelService from './moduleSummary/hotel-service/HotelService';
import { notificationManager } from '../../../utils/NotificationUtils';
import { validateUserSession } from '../../../utils/authUtils';

const HotelSystems = () => {
  const [step, setStep] = useState('moduleSelect');
  const selectedHotel = useSelector(selectedHotelSelector);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const history = useHistory();
  const [updateActiveTab, setUpdateActiveTab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showConfigure, setShowConfigure] = useState(null);

  const [moduleSummaryList, setModuleSummaryList] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      hotelServiceModules: [],
      guestRoomExpModules: [],
      entertainmentModules: [],
    },
  );

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  useEffect(() => {
    if (selectedHotel) {
      setLoading(true);
      getSummaryData(selectedHotel);
      setShowConfigure(null);
    }
  }, [history, selectedHotel]);

  const getSummaryData = async (hotelId) => {
    try {
      const res = await getHotelSystemsModuleSummaryData(hotelId);
      const summaryObj = res.data.getHotelSystemsModuleConfigurations;
      if (summaryObj.isConfirmed) {
        setModuleSummaryList({
          hotelServiceModules: removeTypeName(summaryObj.hotelServiceModules),
          guestRoomExpModules: removeTypeName(summaryObj.guestRoomExpModules),
          entertainmentModules: removeTypeName(summaryObj.entertainmentModules),
        });
        setIsConfirmed(true);
        setStep('moduleSummary');
        setLoading(false);
      } else {
        setStep('moduleSelect');
        setIsConfirmed(false);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      notificationManager('danger', 'Failed to load configs');
    }
  };

  const goToSummeryView = (selectedList) => {
    setModuleSummaryList(selectedList);
    setStep('moduleSummary');
  };

  const onConfirm = (updatedList) => {
    getSummaryData(selectedHotel);
  };

  const handleSectionClick = (section) => {
    setUpdateActiveTab(section);
    setStep('moduleUpdate');
  };

  const handleUpdateModules = (updatedList) => {
    getSummaryData(selectedHotel);
  };

  const removeTypeName = (modules) => {
    modules.forEach((m) => {
      delete m.__typename;
      delete m.enabledDevices.__typename;
    });
    return modules;
  };

  const onConfigClick = (section) => {
    setShowConfigure(section);
  };

  return (
    <div className='container mt-4 hotel-systems'>
      {showConfigure ? (
        showConfigure === GUEST_ROOM_EXP ? (
          <GuestRoomExperience
            onBackButtonClick={() => {
              setShowConfigure(null);
            }}
          />
        ) : showConfigure === HOTEL_SERVICES ? (
          <HotelService
            onBackButtonClick={() => {
              setShowConfigure(null);
            }}
          />
        ) : null
      ) : (
        <>
          <div className='row d-flex'>
            <div className='col-md-6'>
              {step === 'moduleUpdate' && (
                <Button
                  variant='text'
                  color='secondary'
                  size='small'
                  startIcon={<ArrowBack />}
                  onClick={(e) => {
                    setStep('moduleSummary');
                  }}
                  className='me-2'
                >
                  Back
                </Button>
              )}
              <span className='page-title'>Hotel Systems</span>
            </div>
          </div>
          {loading ? (
            <div className='pt-4 col-md-12'>
              <LinearProgressBar />
            </div>
          ) : step === 'moduleSelect' ? (
            <ModuleSelect onLastNextClick={goToSummeryView} />
          ) : step === 'moduleSummary' ? (
            <ModuleSummary
              hotelId={selectedHotel}
              moduleSummaryList={moduleSummaryList}
              isConfirmed={isConfirmed}
              onConfirm={onConfirm}
              onModuleSectionClick={handleSectionClick}
              onConfigClick={onConfigClick}
            />
          ) : (
            step === 'moduleUpdate' && (
              <ModuleListUpdate
                hotelId={selectedHotel}
                onUpdate={handleUpdateModules}
                updateActiveTab={updateActiveTab}
                savedSelectedModuleList={moduleSummaryList}
              />
            )
          )}
        </>
      )}
    </div>
  );
};

export default HotelSystems;
